// 获取链接参数
export const getUrlParam = function (name) {
  return decodeURIComponent((
    new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)')
      .exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null;
}



// WEBPACK FOOTER //
// ./src/tools/getUrlParams/index.js